module.exports = __webpack_public_path__ + "media/images/Branding/HW Small-880f8c359d3deffaf247b2a20dbdb4fd.png";